import React from 'react';

const ApiResponseComponent = ({ message }) => {
  // Replace '\n' with '<br>' to format the text with line breaks
  const sections = message.content.split('\n\n')

  

  return (
    <div>
    <div><p><strong>{message.role === 'user' ? '👤' : '🤖'}:</strong></p></div>
      {sections.map((section, index) => {
        console.log("section", section)
        if (section.startsWith('```') || section.endsWith('```')) {
          return (
            <div key={index}>
              <pre><code dangerouslySetInnerHTML={{ __html: section.replace(/```/g, '') }} /></pre>
            </div>
          );
        } else {
          return (
            <div key={index}>
              <p>
                <span dangerouslySetInnerHTML={{ __html: section.replace(/\n/g, '<br>') }} />
              </p>
            </div>
          );
        }
      })}
    </div>
  );
};

export default ApiResponseComponent;

// <div>
    // {(message.content!==undefined) && <p> <strong>{message.role === 'user' ? '👤' : '🤖'}:</strong>  <div dangerouslySetInnerHTML={{ __html: formattedText }} /></p>}
    // </div>